import React from 'react';
import { APP_STORE_LINKS } from '../../../config/appLinks';

/**
 * Compact official store badges for the red hero only.
 * URLs are the existing App Store / Play links — do not invent new ones.
 * Apple file is the official white badge (legible on the red hero).
 * Play file is the official black badge; Google does not publish a light one.
 */
const HeroStoreBadges = () => {
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div className="fx-hero-stores">
      <a
        href={APP_STORE_LINKS.APPLE_APP_STORE}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Download on the App Store"
      >
        <img
          className="fx-badge-apple"
          src={`${publicUrl}/badges/app-store-badge.svg`}
          alt="Download on the App Store"
          width="120"
          height="40"
        />
      </a>
      <a
        href={APP_STORE_LINKS.GOOGLE_PLAY_STORE}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Get it on Google Play"
      >
        <picture>
          <source type="image/avif" srcSet={`${publicUrl}/badges/google-play-badge.avif`} />
          <source type="image/webp" srcSet={`${publicUrl}/badges/google-play-badge.webp`} />
          <img
            className="fx-badge-play"
            src={`${publicUrl}/badges/google-play-badge.png`}
            alt="Get it on Google Play"
            width="135"
            height="40"
          />
        </picture>
      </a>
    </div>
  );
};

export default HeroStoreBadges;
